import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  Text,
  Stack,
  Input,
  Select,
} from "@chakra-ui/react";
import { FaEllipsisV } from "react-icons/fa";
import Modal_Guardian_pay_Table from "./Modal_Guardian_pay_Table";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Guardian_side_library = () => {
  const [borrowedBooks, setBorrowedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null); // For selected book data to show in modal
  const [data, setData] = useState(false);
  const [students, setStudents] = useState([]);

  const [sortOption, setSortOption] = useState("title"); // Define sortOption state
  const [currentPage, setCurrentPage] = useState(1); // Define currentPage state
  const [rowsPerPage, setRowsPerPage] = useState(10); // Define rowsPerPage state

  const schoolId = sessionStorage.getItem("school_id"); // Replace with actual school ID

  const userId = sessionStorage.getItem("user_id");

  useEffect(() => {
    const fetchGuardianData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/guardian/guardian_profile.php?user_id=${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (data.success) {
          // Ensure students is an array and extract all student IDs
          const studentIds = data.students.map((student) => student.student_id);
          console.log("stu", studentIds);

          setStudents(studentIds);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again.");
      }
    };

    fetchGuardianData();
  }, [userId]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
        );

        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch categories");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching categories");
      }
    };

    if (schoolId) {
      fetchCategories();
    }
  }, [schoolId]);

  const filteredBooks = borrowedBooks.filter((book) => {
    const matchesCategory =
      !selectedCategory || book.category === selectedCategory;
    const matchesSearch =
      !searchQuery ||
      book.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  useEffect(() => {
    const fetchMemberIdAndBooks = async () => {
      try {
        const schoolId = sessionStorage.getItem("school_id");
        console.log("School ID from sessionStorage:", schoolId);

        // Check if schoolId or students array is missing
        if (!schoolId || students.length === 0) {
          setError("School ID or Student IDs are missing.");
          setLoading(false);
          return;
        }

        console.log("Students to process:", students);

        // Iterate over each studentId in the students array
        for (const studentId of students) {
          console.log("Processing studentId:", studentId);

          const memberResponse = await axios.get(
            `${BASE_URL}/student/library/s_membership_details.php?school_id=${schoolId}&student_id=${studentId}`
          );
          console.log(
            "Member response for studentId",
            studentId,
            ":",
            memberResponse.data
          );

          // Ensure comparison between the same data types (string vs. string or number vs. number)
          if (
            memberResponse.data.success &&
            String(memberResponse.data.data.student_id) === String(studentId)
          ) {
            const memberId = memberResponse.data.data.member_id;
            console.log(
              "Found memberId for student",
              studentId,
              ": ",
              memberId
            );

            // Fetch borrowed books using the member_id
            const bookResponse = await axios.get(
              `${BASE_URL}/admin/library/issues/borrowed_books.php?school_id=${schoolId}&member_id=${memberId}`
            );
            console.log(
              "Book response for memberId",
              memberId,
              ":",
              bookResponse.data
            );
            console.log("boo res",bookResponse);
            

            if (
              bookResponse.data.success &&
              bookResponse.data.data.length > 0
            ) {
              console.log("Borrowed books:", bookResponse.data.data);
              setBorrowedBooks(bookResponse.data.data);
              break; // Exit loop once you get data for a valid student
            } else {
              console.log("No books found for memberId", memberId);
              setError("No book taken from library.");
              break;
            }
          } else {
            console.log(
              "Membership details not found or student_id mismatch for studentId",
              studentId
            );
            setError("Membership details not found for student " + studentId);
          }
        }
      } catch (err) {
        console.error("Error occurred during fetching data:", err);

        if (err.response && err.response.status === 404) {
          setError("No book taken from library.");
        } else {
          setError("An error occurred while fetching borrowed books.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMemberIdAndBooks();
  }, [students]);

  console.log("dfgh", borrowedBooks);

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    const sortedBooks = [...borrowedBooks];
    if (e.target.value === "title") {
      sortedBooks.sort((a, b) => a.title.localeCompare(b.title));
    } else if (e.target.value === "name") {
      sortedBooks.sort((a, b) => a.name.localeCompare(b.name));
    }
    setBorrowedBooks(sortedBooks);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredBooks.slice(indexOfFirstRow, indexOfLastRow);
  console.log("n", currentData);

  const totalPages = Math.ceil(filteredBooks.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleOpenModal = (book) => {
    setSelectedBook(book);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBook(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  //   if (error) {
  //     return <div>Error: {error}</div>;
  //   }

  return (
    <Box overflowX="auto" bg="#FBFBFD">
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Library Books</h1>
          <div className="action-buttons"></div>
        </div>

        <div className="breadcrumb">
          <Text as="span">Dashboard</Text> / <Text as="span">Library</Text>
        </div>

        <Box mt={5}>
        <Flex
  direction="column"
  mb={1}
  p={3}
  className="sb"
>
  {/* Row for Rows Per Page */}
  <Flex
    direction={{ base: "column", md: "row" }}
    justify="space-between"
    align="center"
    mb={{ base: 2, md: 3 }}
    w="100%"
  >
    <Flex
      align="center"
      mb={{ base: 2, md: 0 }}
      w={{ base: "100%", md: "auto" }}
    >
     
      <Select
        width={{ base: "100%", sm: "120px" }}
        value={rowsPerPage}
        onChange={(e) => setRowsPerPage(Number(e.target.value))}
        borderColor="#E9EDF4"
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
      </Select>
    </Flex>

    {/* Row for Search and Filter */}
    <Flex
      align="center"
      direction={{ base: "column", md: "row" }}
      spacing={4}
      w="100%"
      justify={{ base: "center", md: "flex-end" }}
      mt={{ base: 2, md: 0 }}
    >
      <Input
        placeholder="Search for books"
        value={searchQuery}
        onChange={handleSearchChange}
        width={{ base: "100%", md: "200px" }}
        borderColor="#E9EDF4"
        mb={{ base: 2, md: 0 }}
      />
      <Select
        value={selectedCategory}
        onChange={handleCategoryChange}
        borderColor="#E9EDF4"
        width={{ base: "100%", md: "200px" }}
        ml={{ base: 0, md: 1 }}
      >
        <option value="">All Categories</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.name}
          </option>
        ))}
      </Select>
    </Flex>
  </Flex>
</Flex>

          <Box overflowX="auto" maxWidth="100%">

          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
            <Thead>
              <Tr>
                <Th>Book Title</Th>
                <Th>Student Name</Th>
                <Th>Due Date</Th>
                <Th>Fine Date</Th>
                <Th>Fine Amount</Th>
                <Th>Payment Mode</Th>
                <Th>Paid</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((book) => (
                <Tr key={book.id}>
                  <Td>{book.title}</Td>
                  <Td>{book.member_name}</Td>
                  <Td>{book.due_date}</Td>
                  <Td>
                    {book.fine_date
                      ? new Date(book.fine_date).toLocaleDateString()
                      : "N/A"}
                  </Td>
                  <Td>{book.fine_amount ? `$${book.fine_amount}` : "N/A"}</Td>
                  <Td>{book.payment_mode || "N/A"}</Td>
                  <Td>{book.paid ? "Yes" : "No"}</Td>
                  <Td>
                    {/* Add the condition to show the Pay button */}
                    {book.status === "Returned" &&
                      book.fine_amount !== null &&
                      book.paid === 0 && (
                        <Button
                          colorScheme="blue"
                          size="xs"
                          alignSelf="flex-end"
                          mt={4}
                          onClick={() => {
                            handleOpenModal();
                            setData(book);
                          }}
                        >
                          Pay
                        </Button>
                      )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          </Box>
          {isModalOpen && (
            <Modal_Guardian_pay_Table
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              amount={data ? data.fine_amount : ""}
              last={data ? data.due_date : ""}
              userId={data?data.student_user_id:""}
              totalAmount={data?data.fine_amount:""}
              fineeId={data?data.fine_id:""}
              memberId={data?data.member_id:""}
              StudentLedgerId={data?data.student_ledger_id:""}


            />
          )}
          <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
              mr={2}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
              ml={2}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </div>
    </Box>
  );
};

export default Guardian_side_library;
